<template>
    <div class="model_info_box">
        <div class="model_card">
            <div class="model_card_box">
                <h2 class="model_name" v-if="modelInfo">{{ modelInfo.name }}</h2>
            </div>
        </div>
        <div class="model_descripion pt-4" v-if="modelInfo && modelInfo.description">
            <h2>Description</h2>
            <div class="model_desc" v-html="modelInfo.description"></div>
        </div>
        <div class="model_accordion pt-4">
            <h3 class="model_accordion_heading">Model Details</h3>
            <div class="model_card">
                <div class="model_accordion_box" v-if="modelInfo">
                    <div class="accordion_box" id="model_accordion">
                        <div class="card" v-if="modelInfo.disease">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse1">
                                    <h3 class="accordion_title">Disease</h3>
                                    <i class="fa fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapse1" class="collapse" data-parent="#model_accordion">
                                <div class="card-body">
                                    <ul class="accordion_content">
                                        <li><span class="key_name">Disease :</span> {{ modelInfo.disease }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="modelInfo.subDisease">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse2">
                                    <h3 class="accordion_title">Sub Disease</h3>
                                    <i class="fa fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapse2" class="collapse" data-parent="#model_accordion">
                                <div class="card-body">
                                    <ul class="accordion_content">
                                        <li><span class="key_name">Sub Disease :</span> {{ modelInfo.subDisease }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="modelInfo.display_name_algorithm">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse3">
                                    <h3 class="accordion_title">Algorithm</h3>
                                    <i class="fa fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapse3" class="collapse" data-parent="#model_accordion">
                                <div class="card-body">
                                    <ul class="accordion_content">
                                        <li><span class="key_name">Algorithm :</span> {{ modelInfo.display_name_algorithm }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="modelInfo.acc">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse4">
                                    <h3 class="accordion_title">Accuracy</h3>
                                    <i class="fa fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapse4" class="collapse" data-parent="#model_accordion">
                                <div class="card-body">
                                    <ul class="accordion_content">
                                        <li><span class="key_name">Accuracy :</span> {{ modelInfo.acc }} %</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="modelInfo.rmse">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse5">
                                    <h3 class="accordion_title">RMSE</h3>
                                    <i class="fa fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapse5" class="collapse" data-parent="#model_accordion">
                                <div class="card-body">
                                    <ul class="accordion_content">
                                        <li><span class="key_name">RMSE :</span> {{ modelInfo.rmse }}</li>
                                    </ul>
                                    <p class="regression_txt_message">We cannot calculate accuracy for a regression model. Instead,
                                    an error metric is used to evaluate like RMSE (Root Mean Square Error).</p>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="modelInfo.specificity">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse6">
                                    <h3 class="accordion_title">Specificity</h3>
                                    <i class="fa fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapse6" class="collapse" data-parent="#model_accordion">
                                <div class="card-body">
                                    <ul class="accordion_content">
                                        <li>{{ modelInfo.specificity_description }}</li>
                                        <li><span class="key_name">Specificity :</span> {{ modelInfo.specificity }} %</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="modelInfo.sensitivity">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse7">
                                    <h3 class="accordion_title">Sensitivity</h3>
                                    <i class="fa fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapse7" class="collapse" data-parent="#model_accordion">
                                <div class="card-body">
                                    <ul class="accordion_content">
                                        <li>{{ modelInfo.sensitivity_description }}</li>
                                        <li><span class="key_name">Sensitivity :</span> {{ modelInfo.sensitivity }} %</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="modelInfo.mcc">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse8">
                                    <h3 class="accordion_title">MCC</h3>
                                    <i class="fa fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapse8" class="collapse" data-parent="#model_accordion">
                                <div class="card-body">
                                    <ul class="accordion_content">
                                        <li>{{ modelInfo.mcc_description }}</li>
                                        <li><span class="key_name">MCC :</span> {{ modelInfo.mcc }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="modelInfo.mae">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse9">
                                    <h3 class="accordion_title">MAE</h3>
                                    <i class="fa fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapse9" class="collapse" data-parent="#model_accordion">
                                <div class="card-body">
                                    <ul class="accordion_content">
                                        <li>{{ modelInfo.mae_description }}</li>
                                        <li><span class="key_name">MAE :</span> {{ modelInfo.mae }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="modelInfo.r_square">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse10">
                                    <h3 class="accordion_title">R Square</h3>
                                    <i class="fa fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapse10" class="collapse" data-parent="#model_accordion">
                                <div class="card-body">
                                    <ul class="accordion_content">
                                        <li>{{ modelInfo.r_square_description }}</li>
                                        <li><span class="key_name">R Square :</span> {{ modelInfo.r_square }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="modelInfo.f1">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse11">
                                    <h3 class="accordion_title">F1 Score</h3>
                                    <i class="fa fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapse11" class="collapse" data-parent="#model_accordion">
                                <div class="card-body">
                                    <ul class="accordion_content">
                                        <li>{{ modelInfo.f1_description }}</li>
                                        <li><span class="key_name">F1 Score :</span> {{ modelInfo.f1 }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="modelInfo.kappa">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse12">
                                    <h3 class="accordion_title">Kappa</h3>
                                    <i class="fa fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapse12" class="collapse" data-parent="#model_accordion">
                                <div class="card-body">
                                    <ul class="accordion_content">
                                        <li>{{ modelInfo.kappa_description }}</li>
                                        <li><span class="key_name">Kappa :</span> {{ modelInfo.kappa }} %</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'modelInfo',
    props: ['modelInfo'],
    data() {
        return {
        }
    }
}
</script>

<style lang="scss" scoped>
.model_info_box {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";

    .model_card {
        // background: rgba(26, 26, 26, 0.5);
        // border: 1px solid rgba(93, 93, 93, 0.4);
        // border-radius: 32px;
        // padding: 30px;

        .model_card_box {
            background: linear-gradient(-30deg, rgba(37, 44, 84, 0.8) 0%, rgba(0, 0, 0, 0.8) 50%, rgba(38, 38, 38, 0.8) 50%, rgba(44, 44, 84, 0.8) 100%);
            padding: 80px 30px;
            border-radius: 32px;
            text-align: center;
            @media only screen and (max-width:767px){
                padding: 60px 15px;
                .model_name{font-size: 24px !important;}
            }

            .model_name {
                color: #fff9db;
                margin: 0px;
                font-size: 34px;
            }
        }
    }

    .model_descripion {
        h2 {
            margin-bottom: 15px;
            font-size: 30px;
            color: #ffc107;
        }
    }
    .model_accordion{
        .model_accordion_heading{
            margin-bottom: 15px;
            font-size: 30px;
            color: #ffc107;
        }
    }

    .accordion_box {
        .card {
            background: linear-gradient(-30deg, rgba(37, 44, 84, 0.8) 0%, rgba(0, 0, 0, 0.8) 50%, rgba(38, 38, 38, 0.8) 50%, rgba(44, 44, 84, 0.8) 100%);
            padding: 0px;
            margin: 20px 0;
            border-radius: 8px;
            -webkit-box-shadow: 0 5px 10px 0 rgba(244, 242, 238, 0.2);
            box-shadow: 0 5px 10px 0 rgba(244, 242, 238, 0.1);
            border: 1px solid rgba(93, 93, 93, 0.4);
            display: block;
            width: 100%;
            /* Hardware acceleration hints */
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            transform: translateZ(0);
            /* Optimize paint performance */
             contain: content;

            .card-header {
                background: transparent;
                padding: 0px;
                border: none;
            }
            .card-body{
              padding-top: 0;
              padding-left: 0;
            }

            .card-link {
                font-size: 18px;
                color: #fff9db;
                line-height: 1;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 15px;
                gap: 15px;
                position: relative;
                padding-right: 40px;

                .accordion_title {
                    margin: 0;
                    font-size: 20px;

                    @media only screen and (max-width:767px) {
                        font-size: 16px;
                    }
                }

                .fa-chevron-down {
                    position: absolute;
                    right: 15px;
                    -webkit-transform: rotate(0deg);
                    -moz-transform: rotate(0deg);
                    -ms-transform: rotate(0deg);
                    transform: rotate(0deg);
                    -webkit-transition: -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
                    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
                }

                &[aria-expanded="true"] {
                    .fa-chevron-down {
                        -webkit-transform: rotate(180deg);
                        -moz-transform: rotate(180deg);
                        -ms-transform: rotate(180deg);
                        transform: rotate(180deg);
                        color: #ffc107;
                    }

                    .accordion_title {
                        color: #ffc107;
                    }
                }
            }

            .accordion_content {
                padding: 0 15px;

                li {
                    font-size: 16px;
                    margin-bottom: 10px;
                    position: relative;
                    color: #fff;
                    line-height: 1.3;
                    text-align: justify;

                    .fa {
                        line-height: 1.3;
                    }

                    &:last-child {
                        margin-bottom: 0px;
                    }
                    .key_name {
                        color: #ffc107;
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
.model_desc {
    font-size: 16px;
    color: #c1c1c1;
    line-height: 1.3;
    text-align: justify;

    p {
        font-size: 16px;
        color: #c1c1c1;
        line-height: 1.3;
        margin-bottom: 15px;

        &:last-child {
            margin-bottom: 0;
        }
    }
}
</style>